import React, { useCallback } from 'react';
import { Button, Row, Typography } from 'antd';
import { ReactComponent as CellphoneIcon } from '../../../../assets/svg/icons/cell.svg';

const { Text } = Typography;

const AppPromotionMessage = ({ onAppPromotionClick }) => {
    return (
        <Row
            align="middle"
            className="msg-item reply-item promotion"
            style={{
                padding: '1rem',
                backgroundColor: 'rgb(253, 238, 183)',
                justifyContent: 'center',
                marginTop: '2rem',
            }}
        >
            <Text style={{ fontSize: '1.3rem', marginRight: '0.4rem' }}>{'Download our '}</Text>
            <CellphoneIcon className="cellphone-animation" />
            <Button
                style={{ padding: 0, fontSize: '1.3rem', marginLeft: '0.4rem' }}
                type="link"
                onClick={onAppPromotionClick}
                className="app-promotion-button"
            >
                mobile application.
            </Button>
            <Text style={{ fontSize: '1.3rem' }}>{" It's fun and easy!"}</Text>
        </Row>
    );
};

export default AppPromotionMessage;
